import { useEffect } from 'react';

function upsertMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export function useDocumentMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;
    upsertMeta('description', description);
    if (keywords) upsertMeta('keywords', keywords);
  }, [title, description, keywords]);
}